import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { EmailPayload } from 'Interfaces/Auth';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: EmailPayload) =>
    $actions.user.sendConformationEmail(dispatch, payload),
  );
};
